/**
 * Created by vladislav on 2/7/2024
 */

connector.sdk = new SdkManager();

connector.player = PlayerInterface();
connector.info = InfoInterface();
connector.platform = PlatformInterface();
connector.social = SocialInterface();
connector.payments = PaymentsInterface();
connector.ads = AdsInterface();
connector.storage = StorageInterface();
connector.conversions = ConversionsInterface();
connector.metrics = MetricsInterface();
connector.cloudStorage = CloudStorageInterface();

connector._playerManager = new PlayerManager();
connector._platformStorage = new PlatformStorage();

connector.onNativeEvent = function (name, data) {
    const plugin = connector.platform.getPlugin();
    if (plugin) {
        plugin.nativeEvent(name, data);
    }
};

connector.notifyActive = function () {
    this.payments.notifyActive();
    this.social.notifyActive();
    this._metrics.registerInput();
};

connector.EVENTS = EVENTS;

connector.initialize = function () {
    console.log(`connector v${connector.version}`);

    const script = connector.utils.getCurrentScript();
    const url = script && script.src || document.URL || "";
    const searchParams = url ? new URL(url).searchParams : new URLSearchParams();
    const dataset = script && script.dataset || {};

    let projectId = searchParams.has("projectId") ? searchParams.get("projectId") : dataset.projectId;
    const studioId = searchParams.has("studioId") ? searchParams.get("studioId") : dataset.studioId;
    let source = searchParams.has("source") ? searchParams.get("source") : dataset.source;
    let payApiURL = searchParams.has("payApiURL") ? searchParams.get("payApiURL") : dataset.payApiUrl;
    let metricsApiURL = searchParams.has("metricsApiURL") ? searchParams.get("metricsApiURL") : dataset.metricsApiUrl;
    let multiApiURL = searchParams.has("multiApiURL") ? searchParams.get("multiApiURL") : dataset.multiApiUrl;
    let notificationsApiURL = searchParams.has("notificationsApiURL") ? searchParams.get("notificationsApiURL") : dataset.notificationsApiUrl;
    let syncApiURL = searchParams.has("syncApiURL") ? searchParams.get("syncApiURL") : dataset.syncApiUrl;
    let remoteConfigURL = searchParams.has("remoteConfigURL") ? searchParams.get("remoteConfigURL") : dataset.remoteConfigUrl;
    const appVersion = searchParams.has("appVersion") ? searchParams.get("appVersion") : dataset.appVersion;

    let manualLogPayments = false;
    let paymentsDisabled = false;
    let norest = false;
    let hybrid = false;

    if (searchParams.get("manualLogPayments") === "true" || dataset.manualLogPayments === "true") {
        manualLogPayments = true;
    }

    if (searchParams.get("paymentsDisabled") === "true" || dataset.paymentsDisabled === "true") {
        paymentsDisabled = true;
    }
    if (searchParams.get("norest") === "true" || dataset.norest === "true") {
        norest = true;
    }

    if (searchParams.get("hybrid") === "true" || new URLSearchParams(window.location.search).get("hybrid") === "true" || dataset.hybrid === "true") {
        hybrid = true;
    }

    if (window.engine === "creator") {
        const localConfig = document.ccConfig;
        projectId = localConfig.name;
        source = localConfig.source;
        payApiURL = localConfig.payApiURL;
        metricsApiURL = localConfig.metricsApiURL;
        multiApiURL = localConfig.multiApiURL;
        notificationsApiURL = localConfig.notificationsApiURL;
        syncApiURL = localConfig.syncApiURL;
        remoteConfigURL = localConfig.remoteConfigURL;
    }

    if (source && [connector.DIGITAL, connector.DIGITALWEB, connector.YOUTUBE, connector.GAMESNACK].includes(source)) {
        norest = true;
    }

    if (!projectId) {
        throw "projectId not specified";
    }

    const needRuApiUrl = () => url.hostname && url.hostname.includes("labsystech")
        || [connector.VK, connector.OK, connector.OKBRIDGE].includes(source)
        || searchParams.has("vk_platform");

    if (!payApiURL && payApiURL !== "") {
        payApiURL = needRuApiUrl()
            ? "https://publication-pay.labsystech.ru/"
            : "https://pay.zareefgaming.com/";
        
        payApiURL += studioId ? `${studioId}_${projectId}` : `${projectId}`;
    }

    const onConfigLoaded = function (config) {
        if (!config && window.CONNECTOR_CONFIG) {
            console.log("[connector] Failed to load config, falling back to local config");
            config = window.CONNECTOR_CONFIG;
        }

        if (!metricsApiURL && config && !config.debugMode) {
            metricsApiURL = needRuApiUrl()
                ? "https://metrics.labsystech.ru/"
                : "https://metrics.cleverappssg.com/";

            metricsApiURL += studioId ? `${studioId}_${projectId}` : `${projectId}`;
        }

        connector.config = Object.assign(config || {}, {
            source,
            payApiURL,
            metricsApiURL,
            multiApiURL,
            notificationsApiURL,
            syncApiURL,
            remoteConfigURL,
            projectId,
            appVersion,
            manualLogPayments,
            paymentsDisabled,
            norest,
            hybrid
        });

        if (document.body) {
            connector._initialize();
        } else {
            document.addEventListener("DOMContentLoaded", () => {
                connector._initialize();
            }, false);
        }
    };

    const bundledConfig = window.CONNECTOR_CONFIG;

    let configURL;

    if (bundledConfig && bundledConfig.remote && bundledConfig.remote.startsWith("remoteconfig://") && remoteConfigURL) {
        // connector.config is not set yet, so _loadConfig cannot resolve the marker here
        configURL = bundledConfig.remote.replace("remoteconfig://", `${remoteConfigURL}/`);
    } else if (payApiURL) {
        configURL = `${payApiURL}/config.json`;
    }

    if (!norest && configURL) {
        let loadFailed = false;
        const loadTimeout = setTimeout(() => {
            loadFailed = true;
            onConfigLoaded(undefined);
        }, 15000);

        const run = () => {
            if (loadFailed) {
                return;
            }

            connector._loadConfig(configURL, (config) => {
                if (loadFailed) {
                    return;
                }

                if (!config) {
                    setTimeout(run, 500);
                    return;
                }

                clearTimeout(loadTimeout);
                onConfigLoaded(config);
            });
        };

        run();
    } else {
        onConfigLoaded(undefined);
    }
};

connector.calcBaseUrl = function () {
    return this.config.payApiURL.substring(0, this.config.payApiURL.lastIndexOf("/") + 1);
};

connector._loadConfig = function (url, callback, options = {}) {
    const attempt = options.attempt !== undefined ? options.attempt : 1;
    const attempts = options.attempts !== undefined ? options.attempts : 1;

    if (url.startsWith("remoteconfig://")) {
        url = url.replace("remoteconfig://", `${connector.config.remoteConfigURL || ""}/`);
    }

    const nextAttempt = () => connector._loadConfig(url, callback, { ...options, attempt: attempt + 1 });

    ConnectorRestClient.load(url, (config, error) => {
        if (!config || error) {
            if (attempt < attempts) {
                console.log(`[connector] failed to load ${url}, retry ${attempt + 1}/${attempts}`);
                setTimeout(nextAttempt, 1000);
                return;
            }

            callback();
            return;
        }

        try {
            config = JSON.parse(config);
        } catch (error) {
            console.error("failed to parse", url, error);
            callback();
            return;
        }

        callback(config);
    });
};

connector._initialize = function () {
    this.dataLoader = new SimpleDataLoader();

    Info.initialize();

    connector._cloudStorage = new CloudStorage();

    const PlatformPluginClass = connector.platform._detectPlugin();
    const platformPlugin = new PlatformPluginClass();
    connector.platform._installPlugin(platformPlugin);

    connector.timeouts = new ConnectorTimeouts();

    this._metrics = new Metrics();

    new ConnectorActionPlayer([
        (f) => {
            window.connectorInitStarted = true;

            if (window.onConnectorInitStart) {
                setTimeout(window.onConnectorInitStart, 0);
            }

            f();
        },

        (f) => platformPlugin.initialize(f),

        (f) => {
            connector.platform.connect();
            SimpleDataLoader.InitTypes();

            f();
        },

        (f) => {
            const localStorage = connector.dataLoader.localStorage;
            if (localStorage.initialize) {
                localStorage.initialize(f);
            } else {
                f();
            }
        },

        (f) => connector._cloudStorage.initialize(f)
    ]).play(() => {
        if (connector.config.migrateLocalStorage) {
            SimpleDataLoader.Migrate();
        }

        const isNewUser = platformPlugin.loadUserId();

        this._predictionManager = new PredictionManager();
        this._metrics.load(isNewUser);
        this._conversions = new Conversions();

        this._countryManager = new CountryManager();
        this._paymentsManager = new PaymentsManager();
        this._adsManager = new AdsManager();
        this._socialManager = new SocialManager();

        this._platformStorage.start();

        const SocialPluginClass = connector.social._detectPlugin();
        if (SocialPluginClass) {
            connector.social._installPlugin(new SocialPluginClass());
        }

        const PaymentsPluginClass = connector.payments._detectPlugin();
        if (PaymentsPluginClass) {
            connector.payments._installPlugin(new PaymentsPluginClass());
        }

        const AdsPluginClass = connector.ads._detectPlugin();
        if (AdsPluginClass) {
            connector.ads._installPlugin(new AdsPluginClass());
        }

        if (connector.notifications) {
            connector.notifications.initialize();
        }

        if (connector.synchronizer) {
            connector.synchronizer.initialize();
            connector.synchronizer.connect();
        }

        window.connectorInited = true;

        if (window.onConnectorInit) {
            setTimeout(window.onConnectorInit, 0);
        }

        connector.social.connect();
        connector.payments.connect();
        connector.ads.connect();

        platformPlugin.subscribeToBrowserEvents();

        if (!connector.config.manualStartMetrics) {
            connector.platform.whenConnected(connector.utils.waitNoMore(10000, () => {
                this._metrics.start();
            }));
        }

        connector.metrics.logEvent(connector.EVENTS.STATS.CONNECTOR_INITIALIZE);

        const connectThrottled = connector.utils.timeredThrottle(10000, () => {
            if (connector.config.disableReconnect) {
                return;
            }

            connector.platform.connect();
            connector.social.connect();
            connector.payments.connect();
            connector.ads.connect();
        });

        connector.platform.on("resume", connectThrottled);
        connector.timeouts.setInterval(connectThrottled, connector.utils.parseInterval("1 minute"));

        ["20 seconds", "40 seconds", "90 seconds"].forEach((timeout) => {
            connector.timeouts.setTimeout(connectThrottled, connector.utils.parseInterval(timeout));
        });
    });
};
